/* eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable newline-after-var */
import React, { useEffect, useRef, useState } from 'react';
import { styled } from 'linaria/react';
import { theme, useBreakpoint, useDidMount } from '@mtsbank/ui-kit';
import { individualOrderClickGtm, mainLoadedCyberGtm } from '@root/utils/gtm/cyber/events';
import { Payee } from '@root/api/ump-catalog-manager';
import { AccordionItem } from './Accordion';
import { Tabs } from './types';
import { CyberNews } from '../CyberNews/CyberNews';
import { ServicesSwitch } from './ServicesSwitch';
import { CyberTop } from '../CyberTop/CyberTop';
import { Spacer } from '../Uikit/Spacer';
import { Sliderbanner } from './SliderBanner';
import { ScrollToTopButton } from './buttons/ScrollToTopButton';
import { ServicesSwitcherTopMobile } from './ServicesSwitcherTopMobile';
import { CyberIndividualOrder } from './CyberIndividualOrder';
import { ModalIndividualOrder } from './Banner/ModalIndividualOrder';
// import { CyberErrorLoad } from './CyberErrorLoad'
// import { ModalBannerError } from './Banner/ModalBannerError'
// import NoSSR from '../NoSSR/NoSSR'
// import { ModalBannerDone } from './Banner/ModalBannerDone'

interface CyberProps {
  tabsServices?: Record<Tabs, Payee[]>;
}
export const Cyber: React.FC<CyberProps> = ({
  tabsServices
}) => {
  const [open, setOpen] = useState(false);
  const individualOrderRef = useRef<HTMLDivElement>(null);
  // const [openModalError, setOpenModalError] = useState<boolean>(
  //   typeof sessionStorage !== 'undefined' && sessionStorage.getItem('bannerShown') !== 'true'
  // )

  // const handleCloseModalError = () => {
  //   setOpenModalError(false)
  //   sessionStorage.setItem('bannerShown', 'true')
  // }

  useEffect(() => {
    setTimeout(() => {
      if (document.location.hash.includes('#individual-order') && individualOrderRef.current) {
        const headerHeight = document.getElementById('header').offsetHeight;
        const topOffset = individualOrderRef.current.getBoundingClientRect().top + window.scrollY - headerHeight;
        window.scrollTo({
          top: topOffset,
          behavior: 'smooth'
        });
      }
    }, 0);
  }, []);
  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
    individualOrderClickGtm();
  };
  const top = tabsServices?.[Tabs.TOP];
  const {
    isMobile
  } = useBreakpoint();
  useDidMount(() => {
    mainLoadedCyberGtm();
  });

  // if (Object.keys(tabsServices).length === 0) {
  //   return <CyberErrorLoad />
  // }

  return <>
      {/* <NoSSR>
        <ModalBannerError
          title="Технические работы 16 сентября"
          description="С 00:00 до 04:00 возможны перебои в проведении платежей"
          open={openModalError}
          handleClose={handleCloseModalError}
        />
       </NoSSR> */}
      <Sliderbanner />
      <Spacer space={64} spacetablet={32} spacemob={16} />
      {isMobile ? <>
          <WrapperText>Популярное</WrapperText>
          <Spacer spacemob={24} />
          <ServicesSwitcherTopMobile top={top} />
        </> : <CyberTop blocks={top} />}

      <Spacer space={64} spacetablet={10} spacemob={32} />
      <ServicesSwitch services={tabsServices} />
      <Spacer space={64} spacetablet={48} spacemob={32} />

      <CyberIndividualOrder ref={individualOrderRef} title="Индивидуальный заказ" text1="Не нашли на нашем сайте подписку, номинал или нужный сервис?" text2="Поможем оформить и оплатить" onClick={handleOpen} />
      <ModalIndividualOrder open={open} handleClose={handleClose} />
      <Spacer space={64} spacetablet={48} spacemob={32} />

      <CyberNews />
      <Spacer space={64} spacetablet={48} spacemob={32} />

      <WrapperTextAccordion>Вопросы и ответы</WrapperTextAccordion>
      <Spacer space={24} />
      <AccordionItem />

      {/* <WidgetCardMir /> */}
      <ScrollToTopButton />
    </>;
};
const WrapperText = /*#__PURE__*/styled("div")({
  name: "WrapperText",
  class: "w1i1440w"
});
const WrapperTextAccordion = /*#__PURE__*/styled("div")({
  name: "WrapperTextAccordion",
  class: "w4bp2nl"
});

require("./Cyber.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./Cyber.tsx");